import { useMemo } from "react";
import { format, getDaysInMonth, setDate } from "date-fns";

const generateDaysArray = (date) => {
  const daysInMonth = getDaysInMonth(date);

  return Array.from({ length: daysInMonth }, (_, index) => {
    const dayNumber = index + 1;
    const currentDate = setDate(date, dayNumber);

    return {
      id: dayNumber,
      week: format(currentDate, "EEE"),
      num: dayNumber,
      date: currentDate,
    };
  });
};

export const useGetCarouselItems = (selectedDate) =>
  useMemo(() => generateDaysArray(selectedDate), [selectedDate]);
